import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography
} from '@mui/material';
import { useEffect } from 'react';
import { Scenario } from '../../../scenarios/types/scenario.model';

interface IScenarioCreateSuccessDialogProps {
  isOpen: boolean;
  message: string;
  imagePath: string;
  // eslint-disable-next-line react/require-default-props
  onClose?: () => void;
}

export default function ScenarioCreateSuccessDialog({
  isOpen,
  imagePath,
  message = 'Scenario Created Successfully',
  onClose
}: IScenarioCreateSuccessDialogProps) {
  useEffect(() => {
    setTimeout(() => {
      if (isOpen) {
        onClose();
      }
    }, 1500);
  }, []);
  return (
    <Dialog open={isOpen} onClose={() => onClose()}>
      <DialogContent
        sx={{ padding: 2 }}
        style={{ width: '320px', height: '130px', textAlign: 'center' }}
      >
        <Grid container justifyContent='center'>
          <img style={{ maxWidth: '80px' }} src={imagePath} alt='success' />
        </Grid>
        <Typography variant='h5' style={{ marginTop: '10px' }}>
          {message}
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
